// <s-scroll-row> — horizontal scroll-snap row with --prev / --next button commands.
class SScrollRow extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', this.#handleCommand, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #handleCommand = (event) => {
    if (event.command !== '--next' && event.command !== '--prev') return;
    const track = this.querySelector('[data-scroll-track]');
    if (!track) return;
    const item = track.firstElementChild;
    const step = item ? item.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    const rtl = getComputedStyle(this).direction === 'rtl';
    let direction = event.command === '--next' ? 1 : -1;
    if (rtl) direction *= -1;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: step * direction, behavior: reduce ? 'auto' : 'smooth' });
  };
}

if (!customElements.get('s-scroll-row')) {
  customElements.define('s-scroll-row', SScrollRow);
}
